<template>
  <div>
    <div class="px-16 pb-10 pt-4" v-show="!state.showViewer">
      <template v-if="licenseUser">
        <div class="w-11/12 flex flex-wrap">
          <zt-button 
            @click="$emit('close');$emit('change-modal', {action: 'approve', request})" 
            icon="check" class="mr-2"
            data-vs-button="approveRequest"
          >
            {{ $t('message.LincensesApprovalPendingComponent.modal.approveTitle') }}
          </zt-button>
          <zt-button 
            @click="$emit('close');$emit('change-modal', {action: 'reject', request})" 
            icon="times" color="secondary"
            data-vs-button="rejectRequest"
          >
            {{ $t('message.LincensesApprovalPendingComponent.modal.rejectTitle') }}
          </zt-button>
        </div>
        <div class="mt-4 flex flex-wrap">
          <div class="pt-2 sm:w-1/2 sm:pr-20">
            <span :class="primaryTextClass" class="text-zt-xl">
              {{ $t('message.LincensesApprovalPendingComponent.labels.employeeInfoTitle') }}
            </span>
            <div class="mt-10">
              <zt-input 
                :value="`${request.nombre} ${request.apellido}`"
                :label="$t('message.LincensesApprovalPendingComponent.labels.nameLastname2')" disabled/>
            </div>
            <div class="mt-10">
              <zt-input :value="licenseUser.dni" data-vs-input="dni" :label="$t('message.LincensesApprovalPendingComponent.labels.dni')" disabled/>
            </div>
            <div class="mt-10">
              <zt-input :value="licenseUser.mail" data-vs-input="mail" :label="$t('message.LincensesApprovalPendingComponent.labels.email')" disabled/>
            </div>
            <div class="mt-10">
              <zt-input 
                :value="licenseUser.numero_legajo.toString()" 
                data-vs-input="numeroLegajo"
                :label="$t('message.LincensesApprovalPendingComponent.labels.fileNumber')" disabled/>
            </div>
          </div>
          <div class="pt-2 sm:w-1/2 sm:pl-10">
            <span :class="primaryTextClass" class="text-zt-xl">
              {{ $t('message.LincensesApprovalPendingComponent.header.title') }}
            </span>
            <div class="mt-10 flex flex-wrap">
              <div class="w-3/5 pr-10">
                <zt-input :value="request.tipo_licencia" data-vs-input="tipoLicencia" :label="$t('message.LincensesApprovalPendingComponent.labels.licenseType')" disabled/>
              </div>
              <div class="w-2/5">
                <zt-input :value="request.dias" data-vs-input="days" :label="$t('message.LincensesApprovalPendingComponent.labels.days')" disabled/>
              </div>
            </div>
            <div class="mt-10">
              <zt-input 
                :value="request.fecha_creacion | woTime" 
                data-vs-input="password"
                :label="$t('message.LincensesApprovalPendingComponent.labels.solicitudeDate')" disabled/>
            </div>
            <div class="mt-10 flex flex-wrap">
              <div class="w-1/2 sm:pr-10">
                <zt-input :value="request.fecha_desde" data-vs-input="startingDate" :label="$t('message.LincensesApprovalPendingComponent.labels.startDate')" disabled/>
              </div>
              <div class="w-1/2">
                <zt-input 
                  :value="request.fecha_regreso" 
                  data-vs-input="finishDate"
                  :label="$t('message.LincensesApprovalPendingComponent.labels.reincorporationDate')" disabled/>
              </div>
            </div>
            <div class="mt-10 flex flex-wrap">
              <div class="w-1/2 pr-10">
                <zt-input :value="balance" :key="key1" :label="balanceMsg" disabled data-vs-input="balance" />
              </div>
              <div class="w-1/2">
                <zt-input :value="daysInThisYear" :key="key2" data-vs-input="daysInThisYear" :label="$t('message.LincensesApprovalPendingComponent.labels.daysInThisYear')" disabled/>
              </div>
            </div>
            <div class="mt-10" v-if="request.observaciones">
              <label class="custom-label pointer-events-none block text-zt-dark-300 truncate zt-label-active">{{$t('message.LincensesApprovalPendingComponent.labels.observations')}}</label>
              <p class="custom-p border-b w-full outline-none bg-transparent text-zt-dark-500" v-html="request.observaciones"></p>
            </div>
            <div class="mt-10" v-if="request.has_upload_document === 't'">
              <div class="sm:w-1/2 pr-10 custom-color-neutral">
                <div class="flex items-center border rounded border-gray-500 p-2">
                  <template v-if="request.license_has_document === 't'">
                    <div class="cursor-pointer" @click="viewFile" data-vs-button="viewFile">
                      <zt-icon name="file-view" class="mr-2 font-size-2rem" :class="primaryTextClass" />
                      <span class="font-size-1rem underline" :class="primaryTextClass">{{ $t('message.LicensesManager.search.viewUploadedFile') }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <zt-icon name="file-quest" class="mr-2 font-size-2rem" />
                    <span class="font-size-1rem underline">{{ $t('message.LicensesManager.search.fileNotUploaded') }}</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-10">
          <v-tabs
            slider-color="#F16B6C"
            class="float-left w-full"
          >
            <v-tab class="float-left" v-for="n in 2" :key="n" @click="licenseTab = n">
              <span
                :class="licenseTab === 1 ? primaryTextClass : 'text-zt-dark-400'"
                v-if="n === 1"
              >{{ $t('message.LincensesApprovalPendingComponent.labels.stateSolicitude') }}</span>
              <span
                :class="licenseTab === 2 ? primaryTextClass : 'text-zt-dark-400'"
                v-if="n === 2"
              >
                {{ $t('message.LincensesApprovalPendingComponent.labels.historyTitle') }}
              </span>
            </v-tab>
            <v-tab-item
              v-for="n in 2"
              :key="n"
              class="py-4"
            >
              <Flow :id-license="request.id" v-if="licenseTab === 1" />
              <HistoryByType :id-user="request.id_usuario" :id-license-type="request.id_tipo_licencia" v-if="licenseTab === 2" />
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
      <template v-else>
        <div class="py-20">
          <vue-loading
            background-color="rgba(0,0,0,0.0)"
            :color="primaryColor"
            :width="100"
            :height="100"
            :is-full-page="false"
            :active="!licenseUser"
          />
        </div>
      </template>
    </div>
    <div v-show="state.showViewer">
      <FileViewer :license-id="request.id"/>
    </div>
  </div>
</template>

<script>
import Flow from './DetailsFlow'
import HistoryByType from './DetailsHistoryByType'
import Licenses from "@/apiClient/Licenses"
import Users from "@/apiClient/Users"
import moment from 'moment'
import FileViewer from './FileViewer'

export default {
  inject: {
    mutations: { default: null },
    state: { default: () => ({}) }
  },
  components: {
    Flow,
    HistoryByType,
    FileViewer
  },
  props: {
    request: {
      type: Object,
      default: {}
    },
    state: {
      type: Object,
      default: {},
    },
    },
  data(){
    return {
      licenseTab: 1,
      licenses: Licenses,
      users: Users,
      licenseUser: '',
      balanceMsg: '',
      balance: '',
      daysInThisYear: '',
      key1: 1,
      key2: 2
    }
  },
  created() {
    this.licenses = new Licenses()
    this.users = new Users()
    this.users
      .getprofileById(this.request.id_usuario)
      .then(r => {
        const data = r.data.results.data[0]
        this.licenseUser = {...data}
      })
      .catch(e => {});
    //Dias acumulados en el año
    let getYearHistoryByType = () => {
      let year = moment().format("YYYY");
      this.licenses
        .getHistoryByType(
          this.request.id_usuario,
          this.request.id_tipo_licencia
        )
        .then(res => {
          let history = res.data.results.data;
          let diasAcumulados = 0;
          for (let key in history) {
            if (history[key].estado_id === '5') {
              let licenseYear = moment(history[key].fecha_desde, "DD/MM/YYYY").format("YYYY");
              if (licenseYear === year) {
                diasAcumulados += parseFloat(history[key].dias);
              }
            }
          }
          this.daysInThisYear = diasAcumulados.toString();
          this.key2++
        })
        .catch(error => {
          this.daysInThisYear = ''
        });
    };
    getYearHistoryByType();
    //Saldo disponible
    let getBalance = () => {
      this.licenses
        .getBalanceByTypeAndUser(
          this.request.id_usuario,
          this.request.id_tipo_licencia
        )
        .then(response => {
          if (response.data.results.data[0].show_details === true) {
            this.balanceMsg = this.$t(
              "message.LincensesApprovalPendingComponent.labels.salaryAvailablePostApprove"
            );
          } else {
            this.balanceMsg = this.$t(
              "message.LincensesApprovalPendingComponent.labels.salaryRegistered"
            );
          }
          this.balance = response.data.results.data[0].available.toString();
          this.key1++
        })
        .catch(error => {
          this.balance = ''
        });
    };
    getBalance();
  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    },
  },
  methods: {
    viewFile(){
      if(this.mutations !== null)
      this.mutations.setShowViewer(true)
    }
  },
  filters: {
    woTime: value => {
      return value.split(" ")[0]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-tabs__div {
  text-transform: none !important;
}

.custom-label {
  font-size: 0.785rem;
  color: #6F6F6F;
}

.custom-p {
  padding: 8px 0;
  border-color: rgba(0, 0, 0, .42);

  &:hover {
    border-color: #464646;
  }
}

.custom-color-neutral {
  color: #707070;
}
.font-size-2rem {
  font-size: 2rem;
}
.font-size-1rem {
  font-size: 1rem;
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>